define(function(require) {
	const modal_tpl = require('./templates/t_lov_modal_detail.hbs');
	const tpl = require('./templates/t_lov_detail.hbs');
	const ElementsListView = require('./v_cpv_elements_list');
	//const panelView = require('./elements/v_lov_panel');

	const ViewManager = require('civicsUtils/view_manager');
	const IpsModel = require('civicsBase/ipsModel');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');

	return Marionette.LayoutView.extend({
		//template: tpl,
		regions: {
			detailRegion:'@ui.detailDiv'
		},
		FILTERCODEMODELID: '',
		ui:{
			detailDiv:'.modal-detail-page',
			saveRowButton:'.save-row-button',
			cancelRowButton:'.cancel-row-button',
			closeButton:'.bbm-btn-close'
		},
		events:{
			'click @ui.saveRowButton':'saveClicked',
			'click @ui.cancelRowButton':'closeClicked',
			'click @ui.closeButton':'closeClicked'
		},
		childEvents: {
			'init:filtercodes': 'initFilterCodes'
		},
		initFilterCodes: function() {
			if (this.moniker !== undefined) {
				let clonedInitialValue = {}
				if (this.values !== undefined) {
					$.extend(true, clonedInitialValue, this.values.toJSON());
				}
				this.addToStore(this.config.portletId, this.moniker, clonedInitialValue);
				this.FILTERCODEMODELID = this.moniker;
				this.setupFilterCodes(this.moniker, true);
			}
		},
		//Marionette Functions Start
		initialize:function(options){
			ViewManager.loading(true);
			this.config = {};
			if(options.config){
				//by copying the config, we prevent updates made to it propogating up and down the view tree.
				//specifically, when setting the readOnlyForm value in the review step, it would disable the form when going back to edit
				//this resulted in empty forms.
				this.config = $.extend(true, {},options.config);
			}

			this.isModal = options.isModal === true;
			if (this.isModal) {
				this.template = modal_tpl;
			} else {
				this.template = tpl;
			}

			this.grid = options.grid;
			if(options.elements){
				this.collection = new IpsModelCollection(options.elements);
			} else if(options.collection){
				this.collection = options.collection;
			}
			if(options.values){
				var val = options.values;
				if(val instanceof IpsModelCollection || val instanceof IpsModel){
					this.values = val;
				} else if(_.isArray(val)){
					this.values = new IpsModelCollection(val);
				} else {
					//default will be a javascript object. convert to IpsModel.
					this.values = new IpsModel(val);
				}
			}

			this.moniker = options.moniker;

			this.newRow = options.newRow === true;
			this.editingRow = options.editingRow === true;

			this.config.readOnlyForm = options.readOnlyForm === true ? true : false;

			//to avoid circular references, just going to pass in the constructor.
			this.config.detailsConstructor = this.constructor;
		},
		onShow:function(){
			if (this.collection) {
				this.elementsView = new ElementsListView({
					config: this.config,
					collection: this.collection,
					values: this.values
				})
				this.detailRegion.show(this.elementsView);
			}
			this.$el.find('.helper-msg').hide();

			//this jquery selector checks for attributes added by the maxlength function.
			//if it finds them, it filters out that text area as it already has the character count applied.
			this.$el.find('textarea:not([aria-labelledby|="character-count-label"])').each(function(index, ta){
				$(ta).maxlength();
			});

			if (this.moniker) {
				ViewManager.setupAutoComplete(this.$el,this.moniker);
				this.initFilterCodes();
			}

			ViewManager.loading(false);
		},
		templateHelpers:function(){
			return {
				isModal:this.isModal,
				editing:this.editingRow,
				readOnlyForm:this.config.readOnlyForm,
				moniker: this.isModal && this.grid ? this.grid.moniker : ''
			};
		},
		//Marionette Functions End
		closeClicked:function(e){
			if(e){
				e.preventDefault();
				e.stopPropagation();
			}

			this.destroy();
		},
		saveClicked:function(e){
			if(e){
				e.preventDefault();
				e.stopPropagation();
			}

			var rowData = this.getData();
			if (rowData != null) {
				this.grid.saveRowClicked(rowData);
				this.destroy();
			} //else there's a validation issue.
		},
		getData: function (skipValidation, checkForEmpty = false) {
			var data = null;
			ViewManager.resetErrorMessages(this);
			if (skipValidation === true || ViewManager.validatePageControl(this.$el)) {
				data = this.elementsView.getData();
				//we use a null return to determine that there was a validation error. 
				//we need to know if we might just have an empty page. This check should return an 
				//empty object if the detail page has no fields.
				data = checkForEmpty && data == null ? {} : data;
				var propsToRemove = [
					'__type',//from RS
					'lastmodifieddatetime',//from RS
					'lastmodifiedby'//from RS
				]

				//add a flag _newRow for new rows being added in a grid.
				if(this.newRow == true){
					data._newRow = true;
				} else{
					propsToRemove.push('_newrow');
				}

				data = this.removeProps(data, propsToRemove);
			}
			return data;
		},
		//takes a string or array of strings and removes matching proprties from the object.
		removeProps: function (obj, propsToDelete) {
			for (var property in obj) {
				var lowerProp = property.toLowerCase();
				if (lowerProp === propsToDelete) {
					delete obj[property];
				} else if(Array.isArray(propsToDelete) && propsToDelete.indexOf(lowerProp)>=0) {
					delete obj[property];
				} else if (typeof obj[property] == 'object') {
					let newJsonData = this.removeProps(obj[property], propsToDelete);
					delete obj.property;
					obj[property] = newJsonData;
				}
			}
			return obj;
		},
		getDeletedRows: function () {
			return this.elementsView.getDeletedRows();
		},
		onDestroy: function () {
		}
	});
});
